var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 11.75C12.0057 11.75 13.125 10.6307 13.125 9.25C13.125 7.86929 12.0057 6.75 10.625 6.75C9.24429 6.75 8.125 7.86929 8.125 9.25C8.125 10.6307 9.24429 11.75 10.625 11.75Z",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.9375H4.375",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.8125H4.375",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.0625H4.375",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.1875H4.375",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 13.6248C7.31169 13.0427 7.8779 12.5703 8.5288 12.2448C9.17969 11.9194 9.89741 11.75 10.6251 11.75C11.3528 11.75 12.0705 11.9194 12.7215 12.2447C13.3724 12.5701 13.9386 13.0426 14.3753 13.6247",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 17.375V3.625C16.875 3.27982 16.5952 3 16.25 3L5 3C4.65482 3 4.375 3.27982 4.375 3.625V17.375C4.375 17.7202 4.65482 18 5 18H16.25C16.5952 18 16.875 17.7202 16.875 17.375Z",
    stroke: "#727272",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/System.f4d17811b7a9a07e684f76c06acc9646.svg";
export { ForwardRef as ReactComponent };